import React from 'react'
import Appointment from '../Appointment/Appointment'

function ScheduleAppointment() {
  return (
    <>
    <Appointment />
    </>
  )
}

export default ScheduleAppointment